'use client';

import dynamic from 'next/dynamic';

const Providers = dynamic(() => import('@/lib/components/layout/providers/Providers'), {
  ssr: false,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const RootLayout = (props: any) => {
  return (
    <Providers {...props}>
      <>{props.children}</>
    </Providers>
  );
};

export default RootLayout;
